import { local } from '@/utils/storage.js'
import { getToken, setToken } from '@/utils/tool.js'
import {
  getUserInfo,
  handleLogin,
  logout,
  handleWebLogin,
} from '@/api/auth'

const USER_INFO_KEY = 'USER_INFO_KEY'
const HAS_GET_INFO_KEY = 'HAS_GET_INFO_KEY'
const USER_INFO_AUDIT_KEY = 'USER_INFO_AUDIT_KEY'
const MENU_LIST_KEY = 'MENU_LIST_KEY'
const BUTTON_LIST_KEY = 'BUTTON_LIST_KEY'

export const state = {
  token: getToken(),
  userAudit: local.getDef(USER_INFO_AUDIT_KEY, false),
  userInfo: local.getDef(USER_INFO_KEY, {}),
  hasGetInfo: local.getDef(HAS_GET_INFO_KEY, false),
  menuList: local.getDef(MENU_LIST_KEY, []),
  buttonList: local.getDef(BUTTON_LIST_KEY, [])
}
export const mutations = {
  SET_TOKEY(state, item) {
    state.token = item
    setToken(item)
  },
  SET_USER_INFO_AUDIT(state, item) {
    state.userAudit = item
    local.set(USER_INFO_AUDIT_KEY, item)
  },
  SET_USER_INFO(state, item) {
    state.userInfo = item
    local.set(USER_INFO_KEY, item)
  },
  SET_HAS_GET_INFO(state, item) {
    state.hasGetInfo = item
    local.set(HAS_GET_INFO_KEY, item)
  },
  SET_MENU_LIST(state, item) {
    state.menuList = item
    local.set(MENU_LIST_KEY, item)
  },
  SET_BUTTON_LIST(state, item) {
    state.buttonList = item
    local.set(BUTTON_LIST_KEY, item)
  }

}
export const getters = {
  token: state => state.token,
  userInfo: state => state.userInfo,
  userAudit: state => state.userAudit,
  userId:  state => state.userId,
  hasGetInfo: state => state.hasGetInfo,
  menuList: state => state.menuList,
  buttonList: state => state.buttonList,
  userAreaId: state => state.userAreaId
}
export const actions = {
  setToken ({ commit }, token) {
    commit('SET_TOKEY', token)
  },
  setUserAudit ({ commit }, status) {
    commit('SET_USER_INFO_AUDIT', status)
  },
  // 账号密码登陆
  handleWebLogin ({ commit }, code) {
    return new Promise((resolve, reject) => {
      handleWebLogin(code).then(res => {
        if (res.status === 200) {
          commit('SET_TOKEY', res.data)
          commit('SET_HAS_GET_INFO', false)
        }
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  // 登陆
  handleLogin ({ commit }, form) {
    return new Promise((resolve, reject) => {
      handleLogin(form).then(res => {
        if (res.status === 200) {
          commit('SET_TOKEY', res.data)
          commit('SET_HAS_GET_INFO', false)
        }
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  // 获取用户相关信息
  getUserInfo ({ commit }) {
    return new Promise((resolve, reject) => {
      try {
        getUserInfo().then(res => {
          const userData = res.data
          if (res.status === 200) {
            const user = {
              id: userData.id,
              userId: userData.userId,
              name: userData.name,
              phone: userData.mobile,
              avatar: userData.avatar,
              roleIds: userData.roleIds,
              level: userData.level,
              jobNumber: userData.jobNumber,
              email: userData.email,
              entryTime: userData.entryTime,
              accountType: userData.accountType,
              deptIdSet: userData.deptIdSet,
              formalStatus: userData.formalStatus
            }
            commit('SET_USER_INFO', user)
            commit('SET_MENU_LIST', userData.menuTree)
            commit('SET_BUTTON_LIST', userData.buttonList)
            commit('SET_USER_INFO_AUDIT', userData.auditStatus)
            commit('SET_HAS_GET_INFO', true)
          } else {
            commit('SET_HAS_GET_INFO', false)
          }
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      } catch (error) {
        reject(error)
      }
    })
  },
  // 退出登录
  handleLogOut ({ commit }) {
    return new Promise((resolve, reject) => {
      logout().then((res) => {
        if (res.status === 200) {
          commit('SET_TOKEY', '')
        }
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  handleClear ({ commit }) {
    commit('SET_TOKEY', '')
    commit('SET_HAS_GET_INFO', false)
  }
}
